<template>
  <div class="login-wrapper">
       <LoginAggr v-if="type=='idcard'"/>
       <Login v-else/>
  </div>
</template>

<script>
import Login from "../../components/user/Login"
import LoginAggr from '../../components/user/LoginAggr'
export default {
    components:{
        Login,
        LoginAggr
    },
    data() {
    return {
      type: 'normal'
    };
  },
    created(){
        this.type = this.$route.query.type
    console.log("login type", this.type);
    },
    methods:{

    }
}
</script>

<style scoped>
.login-wrapper{
    max-width: 500px;
    margin: 50px auto;
    background: #ffffff99;
    padding: 20px;
    box-shadow: #b48ef1 0 0 10px 3px;
}

</style>